<title>Autoverkoop Partner - Bedankt!</title>

<!-- Page Content -->
<div class="container">
    <div class="card border-0 shadow my-5">
        <div class="card-body p-5">
            <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
            <hr>

            <h1 class="font-weight-light">Bedankt voor de extra gegevens!</h1>

            <div class="alert alert-success" role="alert">
                Een e-mail met aanvullende informatie is naar je verzonden.
            </div>

            <p class="lead">Wij laten zo snel mogelijk weten wanneer we de auto bij je op komen halen.</p>

            <button (click)="close()" type="button" class="btn btn-primary btn-lg">Sluiten</button>

            <div style="height: 700px"></div>
        </div>
    </div>
</div>
